<template>
  <div
    :style="cssVars"
    :class="((isInfoEvent || isFutureEvent) && !isListCard ? 'info-card' : '') + ($q.platform.is.mobile ? ' mobile' : '')"
  >
    <div
      v-if="(isInfoEvent || isFutureEvent) && !isListCard"
      class="image-overlay"
    >
      <div
        class="overlay-bkg"
        :style="{ 'background-image': `url(${eventImage ? eventImage : defaultImage})` }"
      />
    </div>
    <q-card
      :ref="eventCode"
      :slug="eventSlug"
      :square="square && !(isInfoEvent || isFutureEvent)"
      :flat="flat && !(isInfoEvent || isFutureEvent)"
      :inline="(isInfoEvent || isFutureEvent) ? false : inline"
      :class="{'text-black': featured, 'mini': !visible.description && !isInfoEventPage}"
      :data-test="CypressTarget('EventCard')"
      :aria-label="ariaEventShortDescription"
      tabindex="0"
      @keydown.native.space.prevent="goToEventSpaceBar"
    >
      <div>
        <q-card-media>
          <div
            v-if="(visible.name || visible.serie || visible.dateTime) && visible.informationOnPoster"
            :class="[(visible.centerTitle || centerTitle) ? 'content-center items-center' : 'content-end items-end']"
            class="eventData row"
          >
            <div
              :class="{ 'content-center items-center fit': (visible.centerTitle || centerTitle) }"
              class="col-xs-12"
            >
              <q-list
                :class="{ 'content-center items-center fit': (visible.centerTitle || centerTitle) }"
                no-border
              >
                <q-item
                  :class="{ 'fit': (visible.centerTitle || centerTitle) }"
                >
                  <q-item-main>
                    <q-item-tile
                      v-if="visible.name && eventName"
                      :class="{
                        'title-card': !(square && flat),
                        'text-center': (visible.centerTitle || centerTitle)
                      }"
                      :data-test="CypressTarget('Name')"
                      class="title"
                    >
                      {{ isOnPreSale ? `[${$t('text.preSales.eventTitleLabel')}]` : '' }}
                      {{ eventName }}
                    </q-item-tile>
                    <q-item-tile
                      v-if="visible.serie && eventSubtitle"
                      :class="{'text-center': (visible.centerTitle || centerTitle)}"
                      :data-test="CypressTarget('Serie')"
                      sublabel
                      class="eventSubtitle"
                    >
                      {{ eventSubtitle }}
                    </q-item-tile>
                    <q-item-tile
                      v-if="visible.dateTime && dateTime"
                      :class="{'text-center': (visible.centerTitle || centerTitle)}"
                      :data-test="CypressTarget('DateTime')"
                      sublabel
                      class="date"
                    >
                      {{ dateTime }}
                    </q-item-tile>
                  </q-item-main>
                </q-item>
              </q-list>
            </div>
          </div>
          <img
            :src="eventImage ? eventImage : defaultImage"
            class="image-media"
            @error="imgErrorManipulator"
          >
          <corner-tab
            v-if="display.soldOutCorner && soldOut && !ticketsInCart"
            :label="$t('label.soldOut')"
            :color="SET_COLOR.primary"
            :text-color="SET_TEXT_COLOR.primary"
          />
          <corner-tab
            v-if="!isInfoEvent && isFutureEvent && isListCard"
            :label="$t('label.soon')"
            :color="SET_COLOR.primary"
            :text-color="SET_TEXT_COLOR.primary"
          />
          <corner-tab
            v-if="isInfoEvent && isListCard"
            :label="$t('label.info')"
            :color="SET_COLOR.primary"
            :text-color="SET_TEXT_COLOR.primary"
          />
        </q-card-media>
        <DataShare
          v-if="!flat"
          :shared="getSharedData"
          :color="SET_COLOR.primary"
        />
        <q-card-title
          v-if="!visible.informationOnPoster || isInfoEventPage"
        >
          <span
            v-if="(visible.name || isInfoEventPage) && eventName"
            class="card-title"
          >
            {{ isOnPreSale ? `[${$t('text.preSales.eventTitleLabel')}]` : '' }}
            {{ eventName }}
          </span>
          <span
            v-if="visible.serie && eventSubtitle"
            slot="subtitle"
          >
            {{ eventSubtitle }}
          </span>
          <span
            v-if="visible.dateTime && dateTime"
            slot="subtitle"
            style="display: block"
          >
            {{ dateTime }}
          </span>
        </q-card-title>
        <div
          v-if="($q.platform.is.mobile || isFutureEvent) && (visible.description || isInfoEventPage)"
          class="menu"
        >
          <menu-button
            v-for="menu in getMenus"
            :key="menu.id"
            :label="menu.label"
            :color="isMenuActive(menu.id) ? SET_COLOR.primary : 'white'"
            :text-color="isMenuActive(menu.id) ? 'white' : 'black'"
            :flat="!isMenuActive(menu.id)"
            class="menu-item"
            @click="clickToMenu(menu.id)"
          />
        </div>
        <q-card-main
          v-if="(visible.main && anyDataInformation) || isInfoEventPage"
          class="no-padding-sides"
        >
          <h1
            v-if="showShortDescription"
            v-dompurify-html="eventShortDescription"
            :data-test="CypressTarget('ShortDescription')"
            class="padding-sides fix-images"
          />
          <div
            v-if="visible.place && eventAddress && (menuActive === getMenuTickets || !($q.platform.is.mobile || isFutureEvent))"
            class="q-mb-sm"
          >
            <q-card-separator />
            <q-list
              no-border
            >
              <q-item>
                <a
                  :href="getLinkPlatform"
                  target="_blank"
                  title="Ver no mapa"
                >
                  <img
                    :id="Rota.id"
                    :src="Rota.icon"
                    :alt="Rota.name"
                    style="margin-top:-10px"
                  >
                </a>
                <q-item-main
                  style="margin-left:22px"
                >
                  <q-item-tile
                    v-if="eventLocationName"
                    label
                  >
                    {{ eventLocationName }}
                  </q-item-tile>
                  <q-item-tile
                    class="q-mb-md"
                    :sublabel="!(!eventLocationName)"
                    :label="!eventLocationName"
                  >
                    <address
                      :data-test="CypressTarget('Address')"
                    >
                      {{ eventAddress }}
                    </address>
                  </q-item-tile>
                </q-item-main>
              </q-item>
            </q-list>
            <q-card-separator v-if="eventTimezone" />
            <q-list
              v-if="eventTimezone"
              no-border
            >
              <q-item>
                <q-item-side icon="language" />
                <q-item-main>
                  {{ showTimezone }}
                </q-item-main>
              </q-item>
            </q-list>
            <div
              v-if="showEventIndicativeClassification && !isInfoEventPage"
              class="eventIndicativeClassification"
            >
              <q-card-separator />
              <q-list
                no-border
              >
                <q-item>
                  <q-item-side>
                    <img
                      class="indicativeClassificationImage"
                      :src="eventIndicativeClassificationImage"
                    >
                  </q-item-side>
                  <q-item-main>
                    {{ indicativeClassificationLabel }}
                  </q-item-main>
                </q-item>
              </q-list>
            </div>
            <q-card-separator v-if="visible.description && !isInfoEventPage && eventDescription" />
          </div>
          <p
            v-if="(isInfoEventPage && !isFutureEvent) || (visible.description && eventDescription && (menuActive === getMenuInformations || (!$q.platform.is.mobile && !isFutureEvent)))"
            v-dompurify-html="eventDescription"
            :data-test="CypressTarget('Description')"
            class="padding-sides fix-images"
          />
          <slot />
        </q-card-main>
      </div>
    </q-card>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import CornerTab from 'components/tabs/corner';
  import DefaultImage from 'assets/default/default.jpg';
  import Rota from 'assets/icons/rota.png';
  import MenuButton from 'components/button/menu/menuButton';
  import { Platform } from 'quasar';

  import {
    TICKET_EVENT_INFORMATION_NAME,
    TICKET_MY_EVENTS_NAME,
    TICKET_MY_EVENTS_INFORMATION_NAME,
  } from 'helpers/constants/vueRouter/ticket';
  import {
    MENU_DEFAULT,
    MENU_TICKETS,
    MENU_INFORMATIONS,
    MENU_PROMOTIONS,
  } from 'helpers/constants/tickets';
  import { createDate } from 'helpers/date/dateConverter';
  import DataShare from 'components/dataShare';
  import Vue from 'vue';

  Vue.prototype.win = window;
  export default {
    name: 'CardEvent',
    components: {
      CornerTab,
      DataShare,
      MenuButton,
    },
    props: {
      spaceEventEnabled: {
        type: Boolean,
        required: false,
        default: false,
      },
      eventName: {
        type: String,
        required: false,
        default: '',
      },
      eventSubtitle: {
        type: String,
        required: false,
        default: '',
      },
      eventDate: {
        type: [String, Date, Object],
        required: false,
        default: '',
      },
      eventImage: {
        type: String,
        required: false,
        default: DefaultImage,
      },
      eventDescription: {
        type: String,
        required: false,
        default: '',
      },
      eventShortDescription: {
        type: String,
        required: false,
        default: '',
      },
      eventLocationName: {
        type: String,
        required: false,
        default: '',
      },
      eventAddress: {
        type: String,
        required: false,
        default: '',
      },
      isListCard: {
        type: Boolean,
        required: false,
        default: false,
      },
      eventGeoCoordinates: {
        type: Object,
        required: false,
        default: () => ({
          latitude: null,
          longitude: null,
        }),
      },
      centerTitle: {
        type: Boolean,
        default: false,
        required: false,
      },
      featured: {
        type: Boolean,
        default: false,
        required: false,
      },
      hasPromotions: {
        type: Boolean,
        default: false,
        required: false,
      },
      square: {
        type: Boolean,
        default: false,
        required: false,
      },
      flat: {
        type: Boolean,
        default: false,
        required: false,
      },
      inline: {
        type: Boolean,
        default: false,
        required: false,
      },
      color: {
        type: String,
        required: false,
        default: 'primary',
      },
      display: {
        type: Object,
        required: false,
        default: () => {
        },
      },
      soldOut: {
        type: Boolean,
        required: false,
        default: false,
      },
      ticketsInCart: {
        type: Boolean,
        required: false,
        default: false,
      },
      eventCode: {
        type: String,
        default: '',
      },
      isInfoEvent: {
        type: Boolean,
        default: false,
      },
      isOnPreSale: {
        type: Boolean,
        default: false,
      },
      eventSlug: {
        type: String,
        default: '',
      },
      dataGroups: {
        type: Array,
        default: () => ([]),
      },
      isFutureEvent: {
        type: Boolean,
        default: false,
      },
      eventTimezone: {
        type: Object,
        required: false,
        default: () => {
        },
      },
      showEventIndicativeClassification: {
        type: Boolean,
        default: false,
      },
      eventIndicativeClassificationImage: {
        type: String,
        default: '',
      },
      eventIndicativeClassificationDescription: {
        type: String,
        default: '',
      },
    },
    data: () => ({
      Rota: {
        id: 'rota',
        name: 'Rota',
        icon: Rota,
      },
      menuActive: MENU_DEFAULT,
    }),
    computed: {
      isInfoEventPage() {
        return (this.isInfoEvent || this.isFutureEvent) && !this.isListCard;
      },
      cssVars() {
        return {
          '--event-image': `url(${this.eventImage})`,
          height: '100%',
        };
      },
      ariaEventShortDescription() {
        return this.eventShortDescription?.replace(/<[^>]*>/g, '');
      },
      defaultImage() {
        return DefaultImage;
      },
      getMenuTickets() {
        return MENU_TICKETS;
      },
      getMenuInformations() {
        return MENU_INFORMATIONS;
      },
      getLinkPlatform() {
        if (Platform.is.mobile) {
          if (Platform.is.android) {
            return `google.navigation:q=${encodeURI(this.eventAddress)}`;
          }
          if (Platform.is.ipad || Platform.is.iphone) {
            return `http://maps.apple.com/?daddr=${encodeURI(this.eventAddress)}`;
          }
        }
        if (Platform.is.desktop) {
          return `https://www.google.com.br/maps/dir//${encodeURI(this.eventAddress)}`;
        }
        return '';
      },
      mapAddress() {
        return `https://www.google.com/maps/place/${encodeURI(this.eventAddress)}${(this.eventGeoCoordinates.latitude && this.eventGeoCoordinates.longitude) ? `/@${this.eventGeoCoordinates.latitude},${this.eventGeoCoordinates.longitude}` : ''}`;
      },
      wazeAddress() {
        return `https://waze.com/ul?q=${encodeURI(this.eventAddress)}&navigate=yes`;
      },
      visible() {
        return {
          dateTime: true,
          description: true,
          informationOnPoster: true,
          main: true,
          name: true,
          place: true,
          serie: true,
          directions: true,
          shortDescription: true,
          centerTitle: false,
          ...this.display,
        };
      },
      dateTime() {
        return this.eventDate
          ? createDate(this.eventDate, { format: 'dd/MM/yyyy HH:mm' })
          : '';
      },
      anyDataInformation() {
        if (this.flat && this.square) {
          return (
            (this.eventShortDescription !== '' && this.visible.shortDescription)
            || (this.eventDescription !== '' && this.visible.description)
            || (this.eventAddress && this.visible.place)
          );
        }
        return (
          !!(this.eventShortDescription && this.visible.shortDescription)
          || !!(this.eventAddress && this.visible.place)
        );
      },
      isAnyDescription() {
        return (
          (this.visible.shortDescription && !!this.eventShortDescription)
          || (this.visible.description && !!this.eventDescription)
        );
      },
      getSharedData() {
        return {
          name: this.eventName,
          text: this.eventSubtitle,
          url: `${window.location.href}/eventInformation/${(this.eventSlug || this.eventCode)}`,
        };
      },
      getMenus() {
        const menus = [
          {
            id: MENU_TICKETS,
            label: this.$t('label.menuTicketsLabel'),
            active: (!!this.eventDescription || this.hasPromotions) && (!this.isInfoEventPage || this.isFutureEvent),
          },
          {
            id: MENU_INFORMATIONS,
            label: this.$t('label.menuInformationsLabel'),
            active: !!this.eventDescription && (!this.isInfoEventPage || this.isFutureEvent),
          },
          {
            id: MENU_PROMOTIONS,
            label: this.$t('label.menuPromotionsLabel'),
            active: this.hasPromotions,
          },
        ];
        return menus.filter((i) => i.active === true);
      },
      showTimezone() {
        if (!this.eventTimezone) {
          return null;
        }
        return this.$i18n.locale.toLowerCase() === 'pt-br' ? this.eventTimezone.name : `UTC ${this.eventTimezone.utc}`;
      },
      indicativeClassificationLabel() {
        return `${this.$t('text.indicativeClassification.label')}: ${this.eventIndicativeClassificationDescription}`;
      },
      showShortDescription() {
        return (
          (this.visible.shortDescription && this.eventShortDescription && !this.isInfoEventPage)
          || (
            (this.$q.platform.is.mobile || this.isFutureEvent)
            && this.visible.shortDescription
            && (!this.isInfoEventPage || this.isFutureEvent)
            && this.eventShortDescription
            && this.menuActive === this.getMenuTickets
          )
        );
      },
    },
    methods: {
      ...mapActions('promotions', [
        'goToPromotions',
      ]),
      goToEventSpaceBar() {
        if (this.spaceEventEnabled) {
          const routeName = this.$route.name === TICKET_MY_EVENTS_NAME
            ? TICKET_MY_EVENTS_INFORMATION_NAME : TICKET_EVENT_INFORMATION_NAME;
          this.$router.replace({
            name: routeName,
            params: {
              code: this.$props.eventSlug || this.$props.eventCode,
            },
          });
        }
      },
      isMenuActive(id) {
        return this.menuActive === id;
      },
      clickToMenu(id) {
        this.menuActive = id;
        if (id === MENU_PROMOTIONS) {
          this.goToPromotions(this.eventName);
        }
      },
    },
  };
</script>

<style lang="stylus" scoped>

div.q-card {
  min-height: 300px;
  height: 100% !important;
}

.info-card .mobile > div.q-card {
  width: 100%;
  border-radius: 0 !important;
  padding: 0;
  margin: 0;
  transform: none;
}

.info-card > div.q-card {
  width: 60%;
  background-color: white;
  border-radius: 11px !important;
  box-shadow: 0px 20px 20px 0px #0000003b !important;
  position: relative;
  padding: 0;
  margin: 0 auto 0;
  transform: translate(0, 20px);
  overflow: hidden;
}

.info-card.mobile > div.q-card {
  width: 100%;
  border-radius: 0 !important;
  padding: 0;
  margin: 0;
  transform: none;
}

.info-card > .image-overlay {
  overflow: hidden;
  position: absolute;
  height: 100%;
  width: 100%;
}

.info-card > .image-overlay > .overlay-bkg {
  height: 100%;
  width: 100%;
  background-size: cover;
  background-position: 50% 50%;
  -webkit-filter: blur(50px) brightness(.9);
  -ms-filter: blur(50px) brightness(.9);
  filter: blur(50px) brightness(.9);
}

.event-data {
  min-height: calc(-98px + 100vh);
}

.info-card > .image-overlay > .image {
  position: absolute;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  -webkit-filter: blur(50px) brightness(.9);
  -ms-filter: blur(50px) brightness(.9);
  filter: blur(50px) brightness(.9);
  display: inline-block;
  width: 200%;
  position: relative;
  top: 50%;
  left: 50%;
}

.info-card {
  overflow: auto;
  padding-bottom: 150px;
  background-color: #e5e5e5;
  @media screen and (max-width: 600px) {
    background-color: #ffffff;
    padding-bottom: 0px;
  }
}

  .q-card.mini
    position:relative
    background:#ffffff
    border-radius:8px
    transition: all .2s ease
    cursor:pointer

  .card-title
    font-weight:700!important
    font-size:16px;

  .padding-sides
    padding 0 20px 0 20px
    font-size:13px;

  .q-card.mini:active
    outline : none
  .q-card.mini:hover
    transform: scale(1.05)
    z-index:9
    transition: all .2s ease
    box-shadow: 0 0 0 8px #f1f1f1

  .q-card:not(.mini) .image-media
    border-radius : 0;
    margin:0 0

  h1
    margin: 0 auto 15px auto
    padding: 0 auto
    font-size: 15px
    font-weight: normal
    letter-spacing: 0

  .eventData {
    background: linear-gradient(180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(130, 130, 130, 0.2) 50%,
    rgba(0, 0, 0, 0.6) 100%)
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    * {
      color: white !important;
    }

    .title {
      font-size 1.45rem
      font-weight 500
    }

    .title-card {
      font-size 1.25rem !important
      font-weight 700
    }

    .eventSubtitle {
      font-size 1.1rem
      font-weight normal
    }

    .date {
      font-size 1.1rem
    }
  }
  .viewMap
    font-size:13px
    color:#666
    border-bottom:1px solid #999
  .menu
    display: flex;
    justify-content: center;
    text-align: center;
    margin-top: 10px;
    margin-bottom: 10px;
    .menu-item
      font-size: 10pt !important;
      font-weight: 600 !important;

  .indicativeClassificationImage {
    height: 32px;
    width: 32px;
  }
</style>
